import { FeatureToggleClientService } from 'feature-toggle-client';
const iframeBannerMarketing = 'iframe-banner-marketing';
const chatbotSdkDebugger = 'chatbot-sdk-debugger';
const showAddContract = 'show-add-contract';
const disableCreateButtonsOnSharedView = 'shared-view-create-buttons';
const blipProfilerHeaderButton = 'blip-profiler-header-button';
export class NavbarFeatures {
    static isMarketingBannerEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(iframeBannerMarketing);
    }
    static isChatbotSdkDebuggerEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(chatbotSdkDebugger);
    }
    static isShowAddContractEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(showAddContract);
    }
    static isCreateButtonsOnSharedViewDisabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(disableCreateButtonsOnSharedView);
    }
    static isBlipProfilerEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(blipProfilerHeaderButton);
    }
    static isBlipInsightsEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled('blip-insights-visibility');
    }
}
